module.exports = __webpack_public_path__ + "static/switcher-chats-70408156becfdf4b0baf261172480204.png";